// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1U8Cb","label":"Radio_label__c5uRJ","checkMark":"Radio_checkMark__1rhCc","disabled":"Radio_disabled__2f1Oa"};